<div class="admin-login-container">
  <mat-card class="login-card">
    <mat-card-header>
      <mat-card-title>Admin Login</mat-card-title>
    </mat-card-header>

    <mat-card-content>
      <div *ngIf="loading" class="loading-state">
        <mat-spinner diameter="40"></mat-spinner>
        <p>Authenticating…</p>
      </div>

      <div *ngIf="error" class="error-message">
        <p>{{ error }}</p>
      </div>

      <button
        *ngIf="!loading"
        mat-raised-button
        color="primary"
        class="login-button"
        data-cy="admin-login-button"
        (click)="onLogin()"
      >
        Login
      </button>
    </mat-card-content>
  </mat-card>
</div>
